import { ca } from '@cian/analytics';
import { getAnalyticsOfferStatus } from '../../../../utils';

export const trackServiceClick = (serviceId: string, isNewOffer: boolean) => {
  ca('eventSite', {
    name: 'oldevent',
    category: getAnalyticsOfferStatus(isNewOffer),
    action: 'publish_terms_block_change_vas',
    label: serviceId,
  });
};

export const trackUnavailableServiceClick = (serviceId: string, isNewOffer: boolean) => {
  ca('eventSite', {
    name: 'oldevent',
    category: getAnalyticsOfferStatus(isNewOffer),
    action: 'publish_terms_block_click_unavailable_vas',
    label: serviceId,
  });
};
